import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetTopLeaguesBySportId = QueryFactory(SD.QueryTypes.GetTopLeaguesBySportId);
//# sourceMappingURL=QGetTopLeaguesBySportId.js.map